import { createFileRoute } from '@tanstack/react-router';
import { useCallback, useEffect } from 'react';
import type { NavigationSectionGroup } from '@/components/Navigation/NavigationCard';
import { CForm } from '@/features/c-form/CForm';
import { CompatibilityEnvironmentSection, LinkSection, MaintenanceSupportSection, OperationalStatusSection, ProvisioningDistributionSection, ResponsibilitySection, SecurityComplianceSection, SoftwareDetailStore, SoftwareIdSection, useSoftwareDetailStore, VendorSection } from '@/features/software/detail';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useSoftware, useUpdateSoftwareDetailMutator } from '../-query';
export const Route = createFileRoute('/_staff/software/$id/_$id/detail/')({
  component: SoftwareDetail
});
function SoftwareDetail() {
  const store = SoftwareDetailStore.createStore();
  return <SoftwareDetailStore.Provider value={store}>
      <Content />
    </SoftwareDetailStore.Provider>;
}
function Content() {
  const {
    id
  } = Route.useParams();
  const {
    data
  } = useSoftware(id);
  const {
    values,
    logo,
    actions
  } = useSoftwareDetailStore();
  useEffect(() => actions.reset(data), [actions, data]);
  const updateSoftwareDetailMutation = useUpdateSoftwareDetailMutator(id);
  const handleSave = useCallback(async () => {
    if (!actions.validate()) {
      throw new Error('Validation failed');
    }
    const result = await updateSoftwareDetailMutation.mutateAsync({
      ...values,
      logoFile: logo.logoFile,
      logoChanged: logo.logoChanged,
      logoDeleted: logo.logoDeleted
    });
    return result;
  }, [actions, updateSoftwareDetailMutation, values, logo]);
  const handleReset = useCallback(() => {
    actions.reset(data);
  }, [actions, data]);
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.software.profile.detail.navigation'
  });
  const navigationSectionGroups: NavigationSectionGroup[] = [{
    titleLabel: t('softwareIdInformation'),
    to: '',
    hash: 'software-id-information'
  }, {
    titleLabel: t('link'),
    to: '',
    hash: 'link'
  }, {
    titleLabel: t('responsibility'),
    to: '',
    hash: 'responsibility'
  }, {
    titleLabel: t('vendor'),
    to: '',
    hash: 'vendor'
  }, {
    titleLabel: t('maintenanceSupport'),
    to: '',
    hash: 'maintenance-support'
  }, {
    titleLabel: t('provisioningDistribution'),
    to: '',
    hash: 'provisioning-distribution'
  }, {
    titleLabel: t('compatibilityEnvironment'),
    to: '',
    hash: 'compatibility-environment'
  }, {
    titleLabel: t('securityCompliance'),
    to: '',
    hash: 'security-compliance'
  }, {
    titleLabel: t('operationalStatus'),
    to: '',
    hash: 'operational-status'
  }];
  return <CForm editUnit="section" itemLayout="label" navigationSectionGroups={navigationSectionGroups} onSave={handleSave} onReset={handleReset}>
      <SoftwareIdSection isAppIntegrationLinked={data.appIntegrationId !== null} />
      <LinkSection />
      <ResponsibilitySection />
      <VendorSection />
      <MaintenanceSupportSection />
      <ProvisioningDistributionSection />
      <CompatibilityEnvironmentSection />
      <SecurityComplianceSection />
      <OperationalStatusSection />
    </CForm>;
}